// extracted by mini-css-extract-plugin
module.exports = {"onlineCourse":"styles_onlineCourse__AH2s8","inPersonCourse":"styles_inPersonCourse___cxE6","offlineCourse":"styles_offlineCourse__LVIkS","usefulBook":"styles_usefulBook__jga0V"};